import BundleProductPriceFactory from "../../../factories/manhattan/bundle/BundleProductPriceFactory";
import {
  IBundleProductPrice,
  IBundleSingleProduct,
  IBundleSingleProductAddon, IBundleProductDisplaySpecification,
  IBundleProductCharacteristic,
  IProductLine
} from "./types";

export default class BundleSingleProduct implements IBundleSingleProduct {

  desc: string;
  descEn: string;
  groupMaster: boolean;
  id: number;
  label: any;
  labelId: number;
  manufacturer: any;
  model: string;
  outlet: boolean;
  productCharacteristics: IBundleProductCharacteristic[];
  productColorsImages: any[];
  productGroupId: any;
  productImages: any[];
  productLine: IProductLine;
  productPrices: IBundleProductPrice[];
  addons: IBundleSingleProductAddon[];
  status: number;
  statusBusiness: number;
  displaySpecifications: IBundleProductDisplaySpecification;

  constructor(
    id: number,
    desc: string,
    descEn: string,
    groupMaster: boolean,
    label: any,
    labelId: number,
    manufacturer: any,
    model: string,
    outlet: boolean,
    productCharacteristics: IBundleProductCharacteristic[],
    productColorsImages: any[],
    productGroupId: any,
    productImages: any[],
    productLine: IProductLine,
    productPrices: IBundleProductPrice[],
    addons: IBundleSingleProductAddon[],
    status: number,
    statusBusiness: number,
    displaySpecifications: IBundleProductDisplaySpecification
  ) {
    this.id = id;
    this.desc = desc;
    this.descEn = descEn;
    this.groupMaster = groupMaster;
    this.label = label;
    this.labelId = labelId;
    this.manufacturer = manufacturer;
    this.model = model;
    this.outlet = outlet;
    this.productCharacteristics = productCharacteristics;
    this.productColorsImages = productColorsImages;
    this.productGroupId = productGroupId;
    this.productImages = productImages;
    this.productLine = productLine;
    this.productPrices = [];
    productPrices.forEach((productPrice: IBundleProductPrice) => {
      this.productPrices.push(BundleProductPriceFactory.create(productPrice));
    });
    this.addons = addons;
    this.status = status;
    this.statusBusiness = statusBusiness;
    this.displaySpecifications = displaySpecifications;
  }

}
